import { connect } from 'react-redux';
import { getIsFetching } from '../../../redux/Reservation/selectors/ro-item';
import { getPaginationQueryOptions } from '../../../redux/Reservation/selectors/ro-item/pagination';
import { getROItemSearchQuery } from '../../../redux/Reservation/selectors/components/ro-item-search';
import {
  onChangeQuery,
  onClearQuery
} from '../../../redux/Reservation/actions/components/ro-item-search';
import { ROItemOnClear } from '../../../redux/Reservation/actions/ro-item';
import { fetchROItems } from '../../../redux/Reservation/sagas/routines';
import ROItemSearch from '../../../components/reservations/ROItemSearch';

function mapStateToProps(state, props) {
  const searchQuery = getROItemSearchQuery(state);
  const paginationQuery = getPaginationQueryOptions(state);
  const queryOptions = { ...paginationQuery, ...searchQuery, page: 1 };
  return {
    ...props,
    searchQuery,
    queryOptions,
    isFetching: getIsFetching(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onSubmit: queryOptions => {
      dispatch(ROItemOnClear());
      dispatch(fetchROItems(queryOptions));
    },
    onChange: query => {
      dispatch(onChangeQuery(query));
    },
    onClear: () => {
      dispatch(onClearQuery());
      dispatch(ROItemOnClear());
      dispatch(fetchROItems({}));
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ROItemSearch);
